import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EAppLanguages } from "../utils/localization";

export const defaultSettings: ISettings = {
    lang: EAppLanguages.FI
}

export interface ISettings {
    lang: EAppLanguages;
}

interface IUseSettingsData {
    settings: ISettings;
    setSetting: <T extends keyof ISettings>(key: T, value: ISettings[T]) => void
}

export type IUseSettingsHook = () => IUseSettingsData;

export const useSettings: IUseSettingsHook = () => {
    const { i18n } = useTranslation();

    const [settings, setSettings] = useState<ISettings>(defaultSettings)

    const setSetting: IUseSettingsData["setSetting"] = (key, value) => {
        if (key === "lang") {
            i18n.changeLanguage(value);
        }
        setSettings((prev) => ({ ...prev, [key]: value }))
    }

    return {
        settings,
        setSetting
    }
};
